/**
 * SEO `<title>` tags for blog detail pages (`/blog/:slug`).
 * Full strings include ` | Databiqs` — keep each entry ≤ 60 characters.
 */
export const BLOG_META_TITLE_BY_ID = {
  1: 'AI Development Company Pakistan | Databiqs',
  2: 'AI Consulting Services for Business | Databiqs',
  3: 'ML Development Services Mistakes | Databiqs',
  4: 'Custom AI vs Off-the-Shelf Tools | Databiqs',
  5: 'Enterprise AI Operating System Guide | Databiqs',
  6: 'Generative AI in Production Guide | Databiqs',
  7: 'MLOps for Small Teams | Databiqs',
  8: 'AI Portfolio Prioritization Guide | Databiqs',
  9: 'RPA and AI Automation Explained | Databiqs',
  10: 'AI Workflow Orchestration Patterns | Databiqs',
  11: 'Document AI for Finance Operations | Databiqs',
  12: 'How to Measure AI ROI | Databiqs',
  13: 'Capital Planning for AI Roadmaps | Databiqs',
  14: 'Board Expectations vs AI Delivery | Databiqs',
  15: 'ML Feature Quality Before Production | Databiqs',
  16: 'Why Analytics Dashboards Fail | Databiqs',
  17: 'Trustworthy Cohort Metrics Guide | Databiqs',
  18: 'AI Personalization Without Privacy Risk | Databiqs',
  19: 'Omnichannel AI Voice & Chat Support | Databiqs',
  20: 'Empathy Metrics for AI Support | Databiqs',
  21: 'RAG Design for FAQ Chatbots | Databiqs',
  22: 'Multi-Turn Chatbot State Management | Databiqs',
  23: 'AI Guardrails for Regulated Industries | Databiqs',
  24: 'AI Executive Workshops That Convert | Databiqs',
  25: 'AI Vendor Evaluation Scorecards | Databiqs',
  26: 'Cross-Functional AI Team Design | Databiqs',
  27: 'Attention Mechanisms for Leaders | Databiqs',
  28: 'Specialized AI Models vs One LLM | Databiqs',
  29: 'Vector Embeddings in Production | Databiqs',
  30: 'Edge and Cloud AI Architecture | Databiqs',
  31: 'Security Reviews for AI Features | Databiqs',
  32: 'Scaling AI Inference Costs | Databiqs',
  33: 'AI Integration Services for Enterprise | Databiqs',
  34: 'Integrate AI Into Business Workflows | Databiqs',
  35: 'AI Application Development Services | Databiqs',
  36: 'Enterprise AI Productivity Solutions | Databiqs',
  37: 'Benefits of AI in Business Operations | Databiqs',
  38: 'AI Chatbots for Customer Service | Databiqs',
  39: 'AI Workflow Automation for Business | Databiqs',
  40: 'Predictive Analytics for Business | Databiqs',
  41: 'Machine Learning Solutions for Enterprise | Databiqs',
  42: 'Generative AI Applications for Business | Databiqs',
};
